//
export enum lineEnum {
  line1 = 'line1',
  line2 = 'line2'
}

// 直播线路
export const lineList = [
  {
    id: lineEnum.line1,
    text: 'Line 1'
  },
  {
    id: lineEnum.line2,
    text: 'Line 2'
  }
];

// 直播列表
export const liveMenuList = [
  {
    id: '1',
    title: 'Lecture Room 1'
  },
  {
    id: '2',
    title: 'Lecture Room 2'
  },
  {
    id: '3',
    title: 'Lecture Room 3'
  },
  {
    id: '4',
    title: 'Lecture Room 4'
  },
  {
    id: '5',
    title: 'Lecture Room 5'
  },
  {
    id: '6',
    title: 'Lecture Room 6'
  },
  {
    id: '7',
    title: 'Lecture Room 7'
  },
  {
    id: '8',
    title: 'Lecture Room 8'
  },
  {
    id: '9',
    title: 'Lecture Room 9'
  },
  {
    id: '10',
    title: 'Lecture Room 10'
  },
  {
    id: '11',
    title: 'Lecture Room 11'
  },
  {
    id: '12',
    title: 'Lecture Room 12'
  },
  {
    id: '13',
    title: 'Lecture Room 13'
  },
  {
    id: '14',
    title: 'Lecture Hall A'
  },
  {
    id: 't1',
    title: 'Youdao Test 1'
  },
  {
    id: 't2',
    title: 'Youdao Test 2'
  },
  {
    id: 't3',
    title: 'Youdao Test 3'
  },
  {
    id: 't4',
    title: 'Youdao Test 4'
  },
  {
    id: 't5',
    title: 'Youdao Test 5'
  }
];
